package com.lightningkite.kiteui

import kotlin.js.Date

actual fun clockMillis(): Double = Date.now()